// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"905565ad","239":"6c1ca83c","455":"76b3e2e1"}[chunkId] + ".chunk.js";
};